export const apiCreate = (): string => '/labels/create'
export const apiList = (id?: string): string =>
  !id ? '/labels/' : `/labels/view/${id}`
export const apiUpdate = (id: string): string => `/labels/update/${id}`
export const apiDelete = (id: string): string => `/labels/delete/${id}`

export const apiListEntityColumns = (): string => '/entityColumns'
